export function addCurrent(templatemessage) {
    return {
        type: 'ADD_CURRENT',
        templatemessage,
    }
}
